import { createAsyncThunk } from "@reduxjs/toolkit";
import { validateFields, closeRequestContactUpdateDialog, openSuccessDialog } from "@requestContactUpdate/store/ducks";
import { requestContactUpdateSelector } from "@requestContactUpdate/store/selectors";
import { openNotificationThunk } from "@store/Notification/thunks";
import { ThunkApiConfig } from "@shared/models/redux";

export interface RequestContactUpdateBody {
  requestType: string;
  request: string;
  entitledAccounts: string[];
  entitledEntities: string[];
  attachmentName?: string;
  attachment?: string;
  customFields?: { [key: string]: any };
}

export const sendRequestContactUpdateThunk = createAsyncThunk<boolean, RequestContactUpdateBody, ThunkApiConfig>(
  "requestContactUpdate/sendRequestContactUpdate",
  async (body, { rejectWithValue, dispatch, extra }) => {
    try {
      const response = await extra<boolean, RequestContactUpdateBody>("/entitlements/v1/user/InvestorRequest", {
        method: "post",
        body,
      });

      if (response.data) {
        // Close the main dialog and open success dialog
        dispatch(closeRequestContactUpdateDialog());
        dispatch(openSuccessDialog());
      }

      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.[0] || "Some error occurred. Please try again.";

      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: errorMessage,
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);

export const submitFormThunk = createAsyncThunk<void, void, ThunkApiConfig>(
  "requestContactUpdate/submitFormThunk",
  (_, { dispatch, getState }) => {
    dispatch(validateFields());

    const { requestType, commonFields, customFields, validationWarningShown } = requestContactUpdateSelector(
      getState()
    );

    if (validationWarningShown) return;

    const fallbackMessage = "Request Contact Update";

    const message =
      commonFields.message && commonFields.message.trim().length > 0 ? commonFields.message : fallbackMessage;

    const body: RequestContactUpdateBody = {
      customFields: {
        ...customFields,
        contactName: commonFields.contactName,
        contactEmail: commonFields.contactEmail,
      },
      requestType: requestType || "",
      request: message,
      entitledAccounts: commonFields.selectedAccounts,
      entitledEntities: commonFields.selectedFunds,
    };

    if (commonFields.attachment) {
      body.attachmentName = commonFields.attachment.name;
      body.attachment = commonFields.attachment.base64;
    }

    dispatch(sendRequestContactUpdateThunk(body));
  }
);
